<template>
	<div class="content Organization">
		<section class="c_section">
			<div class="top_banner company">
				<h1>회사소개</h1>
				<h2>인증현황</h2>
			</div>
		</section>
		<section class="c_section c_tab_container">
			<div class="c_inner">
				<ul class="c_tab">
					<li><router-link to="/greetings">인사말</router-link></li>
					<li><router-link to="/history">연혁</router-link></li>
					<li class="on"><router-link to="/organization">조직도</router-link></li>
					<li><router-link to="/certification_01">인증현황</router-link></li>
					<li><router-link to="/location">찾아오시는길</router-link></li>
				</ul>
			</div>
		</section>
		<section class="c_section">
			<div class="c_inner">
				<div class="img_wrap">
					<img src="@/assets/img/company/img_organization.png" alt="조직도" />
				</div>
			</div>
		</section>
	</div>
</template>

<script setup></script>

<style scoped>
	.img_wrap {
		max-width: 86rem;
		margin: 0 auto;
	}
</style>
